
const Capitalize  = (string) => {
    const returnString = string.charAt(0).toUpperCase() +string.slice(1);
  return ( returnString)
}

export default Capitalize ;